import isEmpty from 'lodash/isEmpty';
import { GetStaticProps, NextPage } from 'next';
import React from 'react';

import HeadMeta from '@/components/static-pages/HeadMeta';
import WhyOutdoorsyTemplate from '@/components/templates/WhyOutdoorsyTemplate';
import { getStaticPageData } from '@/services/getPageData';

interface RoadTrip5xProps {
  heroHeading: string;
  heroImage: string;
  title: string;
  description: string;
  url: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contentBlocks: { type: string; value: any }[];
  noindex: boolean;
}

const RoadTrip5x: NextPage<RoadTrip5xProps> = props => {
  const { title, description, url, noindex } = props;

  return (
    <>
      <HeadMeta title={title} description={description} url={url} noindex={noindex} />
      <WhyOutdoorsyTemplate {...props} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const pageData = await getStaticPageData({ locale, url_path: 'roadtrip5x' });
  if (isEmpty(pageData) || isEmpty(pageData.metadata)) {
    return {
      notFound: true,
    };
  }

  const { heading, hero_image, seo_title, seo_description, url, content_blocks } =
    pageData.metadata;

  return {
    props: {
      heroHeading: heading,
      heroImage: hero_image,
      title: seo_title,
      description: seo_description,
      url,
      contentBlocks: content_blocks,
      noindex: !!pageData.fallback,
    },

    revalidate: 20,
  };
};

export default RoadTrip5x;
